/**
 * @ticket TM-1000001727
 * Entity-Provider fuer das IN-Modul (Integration / Transfer).
 * P8a: reine Route-Registrierungen.
 * P8b: objectRoutes + Object-Components fuer Detail-Pages.
 */
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from '../../core/shared/dto/dto-service/entity-service-registry';
import {MvsCrudModeEnum} from '../../core/shared/service/crud/mvs-crud-mode.enum';
import {
    InIntegrationObjectComponent
} from './component/object-components/in-integration-object-component/in-integration-object.component';
import {
    InTransferRunObjectComponent
} from './component/object-components/in-transfer-run-object-component/in-transfer-run-object.component';

export const IN_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            // TM-1000001727: P8b — objectRoute + Object-Components fuer Detail-Pages.
            ['in.InIntegration', {
                route: '/in/inIntegrations',
                objectRoute: '/in/integration/:id',
                objectComponent: [{mode: MvsCrudModeEnum.update, component: InIntegrationObjectComponent}]
            }],
            ['in.InTransferRun', {
                route: '/in/inTransferRuns',
                objectRoute: '/in/transferRun/:id',
                objectComponent: [{mode: MvsCrudModeEnum.update, component: InTransferRunObjectComponent}]
            }],
        ] as EntityServiceEntry[],
        multi: true
    }
];
